import React from 'react';
import './Menu.css';

const Menu = () => {
  return (
    <div>
      <div className='overlay' />
      <div className='content'>
        <h1>AN ELECTRIC DRIVE</h1>
        <p>Discover your city in a 100% electric taxi...</p>
      </div>
    </div>
  );
};

export default Menu;
